export default {
  computed: {
    showInvalid () {
      return this.showUiValidation !== 'valid' && // show-ui-validation prop allows
        this.errors.has(this.name) && // The field has errors
        !this.hideValidationUi // We're not explicity hiding validation UI
    },
    showValid () {
      return this.showUiValidation !== 'invalid' && // show-ui-validation prop allows
        !this.errors.any() && // The field has no errors
        this.value && // The field has a value
        !this.hideValidationUi && // We're not forcing valid (clearValidation() does this)
        this.isDirty
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/showValidation.js